import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { VaultDateTimePipe } from '@src/app/shared/pipes/vault-date-time.pipe';
import { SharedModule } from '@src/app/shared/shared.module';

/**
 * Item do histórico de versões de um modelo de contrato: o que o painel precisa, comum ao modelo do
 * contrato de parceria e aos modelos dos contratos de cliente (card 3643).
 */
export interface ContractTemplateVersionListItem {
  id: string;
  version: number;
  changeNote?: string | null;
  isCurrent: boolean;
  createdAt: string;
  createdByName?: string | null;
}

/**
 * Histórico de versões do modelo do contrato de parceria (card 3462), no painel lateral da tela do
 * modelo. Clicar numa versão antiga abre o texto dela em leitura; a vigente volta para o editor.
 * Também usado pela tela dos modelos de contrato de cliente (card 3643).
 */
@Component({
  selector: 'app-partner-contract-template-history',
  standalone: true,
  imports: [CommonModule, SharedModule, VaultDateTimePipe],
  templateUrl: './partner-contract-template-history.component.html',
  styleUrls: ['./partner-contract-template-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnerContractTemplateHistoryComponent {
  readonly versions = input<ContractTemplateVersionListItem[]>([]);
  /** Versão aberta em leitura (`null` = editando a vigente). */
  readonly selectedId = input<string | null>(null);
  readonly loading = input(false);

  readonly selectVersion = output<ContractTemplateVersionListItem>();
  readonly collapse = output<void>();
}
